<template>
    <form class="is-clearfix">
        <h1 class="title is-3">Edit task</h1>
        <div class="columns">
            <div class="column">
                <o-field label="Subject">
                    <o-input v-model="task.subject"></o-input>
                </o-field>

                <o-field label="Created At">
                    <datepicker placeholder="Select a date" v-model="task.createdAt" ></datepicker>
                </o-field>

                <o-field label="Due Date">
                    <datepicker placeholder="Select a date" v-model="task.dueDate" ></datepicker>
                </o-field>

                <o-field label="Location">
                    <o-select placeholder="Select a location" v-model="task.location" expanded>
                        <option
                            v-for="location in locations"
                            :value="location.id"
                            :key="location.id">
                            {{ location.name }}
                        </option>
                    </o-select>
                </o-field>

            </div>

            <div class="column">
                <o-field label="Status">
                    <o-select placeholder="Select a status" v-model="task.status" expanded>
                        <option
                            v-for="status in statuses"
                            :value="status.id"
                            :key="status.id">
                            {{ status.name }}
                        </option>
                    </o-select>
                </o-field>

                <o-field label="Assigned To">
                    <o-select placeholder="Select a user" v-model="task.assignedTo" expanded>
                        <option
                            v-for="user in users"
                            :value="user.id"
                            :key="user.id">
                            {{ user.name }}
                        </option>
                    </o-select>
                </o-field>

                <o-field label="Description">
                    <o-input maxlength="200" type="textarea" v-model="task.description"></o-input>
                </o-field>

                <div class="field">
                    <o-checkbox v-model="task.emailNotification">Email Notification</o-checkbox>
                </div>

            </div>
        </div>

        <div class="field is-grouped is-pulled-right">
            <p class="control">
                <router-link :to="{ name: 'tasks.index' }" class="button" >Cancel</router-link>
            </p>
            <p class="control">
                <button @click.prevent="confirmCustomDelete" class="button is-danger">Delete</button>
            </p>
            <p class="control">
                <button @click.prevent="success" class="button is-success">Save</button>
            </p>
        </div>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isComponentModalActive" has-modal-card>
            <note-modal/>
        </o-modal>
    </form>
</template>

<script>
    import Datepicker from '../../components/Datepicker';
    import NoteModal from '../../components/modals/Note';

    export default {
        components: {
            Datepicker,
            NoteModal
        },

        data() {
            return {
                locations: [
                    {"id": 1,"name": "BEST Squad"},
                    {"id": 2,"name": "Cushman and Wakefield"},
                    {"id": 3,"name": "Department of Finance"},
                    {"id": 4,"name": "Department of Transportation"},
                    {"id": 5,"name": "FDNY"},
                    {"id": 5,"name": "NYC Depart. of Buildings-Staten Island"},
                    {"id": 5,"name": "NYC DOB - Bronx Borough Office"},
                    {"id": 5,"name": "NYC DOB - Brooklyn Office"},
                    {"id": 5,"name": "NYC DOB - Manhattan Office"},
                    {"id": 5,"name": "NYC DOB - Queens Borough Office"},
                    {"id": 5,"name": "NYC Landmarks Preservation Commission"},
                    {"id": 5,"name": "RICONDA MAINTENANCE, INC"},
                    {"id": 5,"name": "School Construction Authority (SCA)"},
                ],

                statuses: [
                    {"id": 1, "name": "Task Status"},
                    {"id": 2, "name": "In Progress"},
                    {"id": 3, "name": "Completed"},
                    {"id": 4, "name": "Deferred"},
                    {"id": 5, "name": "Waiting"},
                ],

                users: [
                    {"id": 1, "name": "ChlseaY"},
                    {"id": 2, "name": "ChrisH"},
                    {"id": 3, "name": "DanielB"},
                    {"id": 4, "name": "ElenaR"},
                    {"id": 5, "name": "EmilyS"},
                    {"id": 6, "name": "ErikW"},
                ],

                task: {
                    subject: 'File Project',
                    createdAt: '01/24/2017',
                    dueDate: '01/25/2017',
                    location: 1,
                    status: 2,
                    assignedTo: 3,
                    description: 'Please submit FA filing with the attached forms and check. Thank You.',
                    emailNotification: 1,
                },
                isComponentModalActive: false,
            }
        },

        methods: {
            success() {
                this.$swal.fire({
                    text: 'Task was successfull updated',
                    icon: 'success'
                })
            },
            confirmCustomDelete() {
                this.$swal.fire({
                    title: 'Deleting contact',
                    text: 'Are you sure you want to <strong>delete</strong> this contact? This action cannot be undone.',
                    confirmText: 'Delete Contact',
                    icon: 'error',
                    hasIcon: true,
                    onConfirm: () => {
                        this.$swal.fire('Contact deleted!')
                    }
                })
            },
            danger() {
                this.$swal.fire({
                    duration: 5000,
                    text: 'Task can\'t be deleted',
                    position: 'is-bottom',
                    icon: 'error'
                })
            }
        }
    }
</script>
